import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ButtonColorEnum } from 'src/app/shared/buttons/enums/button-color.enum';
import { InputTypeEnum } from 'src/app/shared/input/enums/input-type.enum';
import { GetCategoryRequest } from '../service/models/category.service.model';
import { StatusEnum } from 'src/app/common/utils/status-enum.models';
import {
  GetClientRequest,
  GetClientsResponse,
} from '../../client/models/client.model';
import { ClientService } from '../../client/service/client.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-category-filter',
  templateUrl: './category-filter.component.html',
  styleUrls: ['./category-filter.component.scss'],
})
export class CategoryFilterComponent {
  constructor(
    public formBuilder: FormBuilder,
    public clientService: ClientService,
    public toastrService: ToastrService
  ) {}

  @Output() filterEmmiter: EventEmitter<GetCategoryRequest> =
    new EventEmitter<GetCategoryRequest>();

  form = this.formBuilder.group({
    name: '',
    status: [[]],
    initialDate: [''],
    finalDate: [''],
    clients: [[]],
  });

  isOpen: boolean = false;
  status: string[] = [];
  selectedStatus: string[] = [];
  isLoading: boolean = false;

  clientOptions: string[] = [];
  originalClients: GetClientsResponse[] = [];
  selectedClients: string[] = [];
  loadingClients: boolean = false;
  loadingSearchClients: boolean = false;
  totalItemsClients: number = 0;
  loadingMoreClients: boolean = false;

  clientsFilter = {
    pageSize: 10,
    pageNumber: 1,
    status: [StatusEnum.ATIVO],
    sortAscending: true,
    sortBy: 'Name'
  } as GetClientRequest;

  get ButtonColorEnum() {
    return ButtonColorEnum;
  }

  get InputTypeEnum() {
    return InputTypeEnum;
  }

  ngOnInit() {
    this.populateStatus();
    this.getClients(null);
  }

  populateStatus() {
    this.status = [StatusEnum.ATIVO, StatusEnum.INATIVO, StatusEnum.EXCLUIDO];
  }

  handleToggleAccordion() {
    this.isOpen = !this.isOpen;
  }

  clear() {
    this.form.reset();
    this.selectedStatus = [];
    this.selectedClients = [];
  }

  getClients(name: string | null) {
    this.clientsFilter.pageNumber = 1;

    if (name != null) {
      this.clientsFilter.name = name;
      this.loadingSearchClients = true;
    } else this.loadingClients = true;

    this.clientService.get(this.clientsFilter).subscribe({
      next: (data) => {
        this.originalClients = data.items;
        this.clientOptions = data.items.map((i) => i.name + ' | ' + i.cnpj);
        this.totalItemsClients = data.totalItems;
        this.loadingClients = false;
        this.loadingSearchClients = false;
      },
      error: () => {
        this.toastrService.error('Não foi possível carregar os Clientes.');
        this.loadingClients = false;
        this.loadingSearchClients = false;
      },
    });
  }

  getMoreClients() {
    if (this.totalItemsClients != this.clientOptions.length) {
      this.loadingMoreClients = true;
      if (this.clientsFilter.pageNumber) this.clientsFilter.pageNumber += 1;
      this.clientService.get(this.clientsFilter).subscribe({
        next: (data) => {
          this.originalClients = this.originalClients.concat(data.items);
          this.totalItemsClients = data.totalItems;

          this.clientOptions = this.clientOptions.concat(
            data.items.map((i) => i.name + ' | ' + i.cnpj)
          );

          this.loadingMoreClients = false;
        },
        error: () => {
          this.toastrService.error('Não foi possível carregar os Clientes.');
          this.loadingMoreClients = false;
        },
      });
    }
  }

  getClientsIdFromText(clients: string[]): string[] {
    if (!clients || clients.length === 0) return [];
    let clientsId: string[] = [];
    clients.forEach((name) => {
      let clientName = name.split('|')[0].trim();
      let client = this.originalClients.find((i) => i.name.trim() === clientName.trim());
      if (client) clientsId.push(client.id);
    });

    return clientsId;
  }

  search() {
    var clientIds = this.getClientsIdFromText(
      this.form.controls.clients.value ?? []
    );

    let filter: GetCategoryRequest = {} as GetCategoryRequest;

    filter.name = this.form.controls.name.value ?? '';
    filter.status = this.form.controls.status.value ?? null;
    filter.startDate = this.form.controls.initialDate.value ?? '';
    filter.endDate = this.form.controls.finalDate.value ?? '';
    filter.clientIds = clientIds;

    this.filterEmmiter.emit(filter);

    this.isOpen = false;
  }
}
